if (!customElements.get('feature-tooltip')) {
class FeatureTooltip extends HTMLElement {
    static TOP = 'top';
    static BOTTOM = 'bottom';
    static LEFT = 'left';
    static RIGHT = 'right';

    connectedCallback() {
        console.log('[FeatureTooltip] connectedCallback - element connected:', this.className);
        // Wait for DOM content to be parsed
        this.tooltipHandler();
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeyDown);
    }

    tooltipHandler = () => {
        // Since this element IS the tooltip container, we work with 'this' directly
        const tooltip = this;
        console.log('[FeatureTooltip] tooltipHandler - setting up click listener on:', tooltip.className);

        // Handle clicks on this specific tooltip
        tooltip.addEventListener('click', (e) => {
            console.log('[FeatureTooltip] CLICK detected on tooltip!');
            console.log('[FeatureTooltip] Click target:', e.target.className);
            console.log('[FeatureTooltip] Window width:', window.innerWidth);
            
            const tooltipCard = tooltip.querySelector('.js-feature-tooltip__product-card-link');
            console.log('[FeatureTooltip] tooltipCard found:', !!tooltipCard);

            if (!tooltipCard) {
                console.log('[FeatureTooltip] No tooltipCard found, returning early');
                return;
            }

            const isAlreadyActive = tooltip.classList.contains('active');
            console.log('[FeatureTooltip] isAlreadyActive:', isAlreadyActive);

            // Close all other tooltips (find all tooltip instances on the page)
            document.querySelectorAll('feature-tooltip').forEach((t) => {
                if (t !== tooltip) {
                    t.classList.remove('active');
                    const card = t.querySelector('.js-feature-tooltip__product-card-link');
                    if (card) card.classList.remove('active');
                }
            });

            // Toggle this tooltip only on mobile (<1200px)
            if (!isAlreadyActive && window.innerWidth < 1200) {
                console.log('[FeatureTooltip] Activating tooltip (mobile mode)');
                tooltip.classList.add('active');
                tooltipCard.classList.add('active');
            } else {
                console.log('[FeatureTooltip] Deactivating tooltip or desktop mode (hover only)');
                tooltip.classList.remove('active');
                tooltipCard.classList.remove('active');
            }
        });
    };

    handleDocumentClick = (e) => {
        console.log('[FeatureTooltip] Document click detected, target:', e.target.className);
        
        // If clicking a mobile dot, open its matching tooltip card at the bottom and stop
        const mobileDot = e.target.closest('.feature-tooltip__card-dot.dot-mobile');
        if (mobileDot) {
            console.log('[FeatureTooltip] Mobile dot clicked!');
            const key = mobileDot.getAttribute('data-tooltip-key');
            console.log('[FeatureTooltip] Mobile dot key:', key);
            if (!key) return;
            // Close all first
            document.querySelectorAll('feature-tooltip').forEach((t) => {
                t.classList.remove('active');
                const c = t.querySelector('.js-feature-tooltip__product-card-link');
                if (c) c.classList.remove('active');
            });

            // Find matching tooltip for this dot
            const targetTooltip = document.querySelector(`feature-tooltip[data-tooltip-key="${key}"]`);
            console.log('[FeatureTooltip] Target tooltip found:', !!targetTooltip);
            if (targetTooltip) {
                const card = targetTooltip.querySelector('.js-feature-tooltip__product-card-link');
                if (card) {
                    console.log('[FeatureTooltip] Activating mobile tooltip');
                    targetTooltip.classList.add('active');
                    card.classList.add('active');
                }
            }
            return;
        }

        // Close all tooltips when clicking outside any tooltip (and not on mobile dot)
        if (!e.target.closest('feature-tooltip')) {
            console.log('[FeatureTooltip] Clicked outside tooltip, closing all');
            document.querySelectorAll('feature-tooltip').forEach((tooltip) => {
                tooltip.classList.remove('active');
                const card = tooltip.querySelector('.js-feature-tooltip__product-card-link');
                if (card) card.classList.remove('active');
            });
        }
    };

    handleKeyDown = (e) => {
        // Close all tooltips on Escape key
        if (e.key === 'Escape') {
            document.querySelectorAll('feature-tooltip').forEach((tooltip) => {
                tooltip.classList.remove('active');
                const card = tooltip.querySelector('.js-feature-tooltip__product-card-link');
                if (card) card.classList.remove('active');
            });
        }
    };
}

customElements.define('feature-tooltip', FeatureTooltip);
}
